import * as base64url from '../helpers/base64url'

sessionStorage.removeItem('accounts')


const meta = 'login'
window[`fnc_${meta}`] = initLoginPage

document.addEventListener("loadPage", () => {
    const evMeta = document.querySelector('meta[name="eventListener"]')
    if (evMeta !== null && evMeta['content'] === meta) {
        document.addEventListener("appReady", () => {
            if (DEBUG) console.log((`Initializing ${meta} page`))
            window[`fnc_${meta}`]()
        })
    }
})
    

async function initLoginPage() {   
    document.getElementById('siw-public-key').addEventListener('click', function(event) {
        if (!window.PublicKeyCredential) {
            alert('Passkeys are not supported by this browser')
            return
        }
        
        event.preventDefault()
       
        triggerWebAuthn()
    })

       
    if (window.PublicKeyCredential && PublicKeyCredential.isConditionalMediationAvailable) {
        const available = await PublicKeyCredential.isConditionalMediationAvailable() 

        if (!available)
            return
    
        //$('.touch-id-elm').addClass('visually-hidden')

        const c = helpers.getCookie('hasPasskey')

        if (typeof c !== 'undefined')
            triggerWebAuthn()
    }
}

async function triggerWebAuthn() {
    const params = {
        _csrf: $("meta[name=_csrf]").attr("content")
    }

    navigator.credentials.preventSilentAccess()

    $.ajax({
        url: '/webauthn/login/public-key/challenge',
        method: 'POST',
        data: params,
        success: async function (json) {  
            if (DEBUG) console.log(json)

            try {
                const credential = await navigator.credentials.get({
                    mediation: 'required',
                    publicKey: {
                        rpId: window.location.host,
                        challenge: base64url.decode(json.challenge),
                        timeout: 60000,
                        userVerification: 'preferred'
                    }
                })

                var body = {
                    id: credential.id,
                    response: {
                        clientDataJSON: base64url.encode(credential['response']['clientDataJSON']),
                        authenticatorData: base64url.encode(credential['response']['authenticatorData']),
                        signature: base64url.encode(credential['response']['signature']),
                        userHandle: credential['response']['userHandle'] ? base64url.encode(credential['response']['userHandle']) : null
                    },
                }

                if (credential['authenticatorAttachment']) {
                    body['authenticatorAttachment'] = credential['authenticatorAttachment']
                }

                body['_csrf'] = $("meta[name=_csrf]").attr("content")
        
                $.ajax({
                    url: '/webauthn/login/public-key',
                    method: 'POST',
                    data: JSON.stringify(body),
                    contentType: 'application/json',
                    success: async function (json) {  
                        if (DEBUG) console.log(json)

                        window.location.href = json.location

                    },
                    error: function (err) {
                        helpers.alert(err)
                    }
                })
            } catch(e) {
                $('.touch-id-elm').removeClass('visually-hidden')
            }
        },
        error: function (err) {
            helpers.alert(err)
        }
    })
}